module.exports = __webpack_public_path__ + "static/media/CV_SusanneSchuett_Frontend.4ca9ba06.pdf";